/******/ (() => { // webpackBootstrap
class CartUpdate extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('textarea');
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-update'});
    if (!this.input) return;
    // Modal fields are saved explicitly so navigation cannot race an unawaited change request.
    if (!this.closest('cart-update-modal')) {
      this.input.addEventListener('change', this.handleInputChange);
    }
  }

  handleInputChange(e) {
    this.save(e.target.value).catch((error) => console.error('Failed to save cart note:', error));
  }

  async save(value = this.input.value) {
    const name = this.input.name;
    const bodyObj = this.fetchBody(name, value);
    if (!bodyObj) throw new Error('Unsupported cart note field');

    const response = await fetch(window.routes.cart_update_url, {
      ...this.fetchConfig(),
      body: JSON.stringify(bodyObj)
    });
    if (!response.ok) throw new Error(`Cart update failed (${response.status})`);

    const cart = await response.json();
    const attribute = name.match(/^attributes\[(\w+)\]$/);
    const savedValue = attribute ? cart.attributes?.[attribute[1]] : cart.note;
    if ((savedValue ?? '') !== value) throw new Error('Cart update was not confirmed');
    return cart;
  }

  fetchBody(name, value) {
    /* ===== Cart note update ===== */
    if (name === 'note') {
      return { note: value };
    }

    /* ===== Cart attribute update ===== */
    const match = name.match(/^attributes\[(\w+)\]$/);
    if (match) {
      return { attributes: { [match[1]]: value } };
    }

    return null;
  }

  fetchConfig(type = 'json') {
    /* ===== Create the fetch configuration object ===== */
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
}

customElements.define('cart-update', CartUpdate);
/******/ })()
;
